import { RackDetails } from "@gtpl/shared-models/masters";
import { ZoneMaster } from "../../zone-master/zone-master.entity";
import { Rack } from "../racks.entity";
import { RackDTO } from "./racks.dto";

export class RackAdapter {
    convertDtoToEntity(dtoObj: RackDTO,  isUpdate: boolean = false ): Rack {
        try {
            const entityObj = new Rack();
            entityObj.zoneMasterInfo = new ZoneMaster();
            entityObj.rackId = dtoObj.rackId;
            entityObj.zoneMasterInfo.zoneId = dtoObj.zoneId;
            entityObj.reservedForDummy = dtoObj.reservedForDummy;
            entityObj.rackName = dtoObj.rackName;
            entityObj.allocatedPlantId = dtoObj.plantId;
            entityObj.allocatedZoneId = dtoObj.zoneId;
            entityObj.plantId = dtoObj.plantId;entityObj.rackCode=dtoObj.rackCode;
            if (isUpdate) {
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }
  

    public convertEntityToDto(rackObject: Rack): RackDTO {
        const racksDTO= new RackDTO;
        racksDTO.rackId = rackObject.rackId;
        racksDTO.zoneId = rackObject.zoneMasterInfo.zoneId;
        racksDTO.zoneName = rackObject.zoneMasterInfo.zoneName;
        racksDTO.rackName = rackObject.rackName;
        racksDTO.rackCode = rackObject.rackCode;
        racksDTO.reservedForDummy = rackObject.reservedForDummy;
        racksDTO.plantId = rackObject.plantId
        racksDTO.isActive = rackObject.isActive;
        racksDTO.createdAt = rackObject.createdAt;
        racksDTO.updatedAt = rackObject.updatedAt;
        racksDTO.createdUser = rackObject.createdUser;
        racksDTO.updatedUser = rackObject.updatedUser;
        racksDTO.versionFlag = rackObject.versionFlag;
        racksDTO.allocatedPlantId = rackObject.allocatedPlantId;
        racksDTO.allocatedZoneId = rackObject.allocatedZoneId;
        return racksDTO;
      }

      public convertEntityDetails(rackObject: Rack): RackDetails {
        const racksDetails= new RackDetails(rackObject.rackId, rackObject.rackName, rackObject.rackCode,rackObject.reservedForDummy,rackObject.zoneMasterInfo.zoneId,rackObject.zoneMasterInfo.zoneName,rackObject.createdUser, rackObject.updatedUser,rackObject.isActive,rackObject.versionFlag,rackObject.allocatedZoneId,rackObject.allocatedPlantId);
        return racksDetails;
      }
}
